module.exports = "/v8.47.1/6d19211/bundles/opensearch.xml";